module.exports = __webpack_public_path__ + "img/encore-un-instant.71c8dc0e.jpg";